export enum MaritalStatus { 
    Married=1,
    Separeted=2,
    Widowed=3,
    Divorced=4,
    SingleOrNeverMarried=5
}